import {
	Avatar,
	AvatarFallback,
	AvatarImage,
} from '#app/components/ui/avatar.tsx'
import davidSacksAvatar from './davidsacks.jpg'

const TWEET_URL = 'https://x.com/DavidSacks/status/1078755080478715904'

function XLogo({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 24 24"
			aria-hidden
			className={className}
			fill="currentColor"
		>
			<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
		</svg>
	)
}

function VerifiedBadge({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 24 24"
			aria-label="Verified account"
			className={className}
			fill="#1d9bf0"
		>
			<path d="M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81c-.66-1.31-1.91-2.19-3.34-2.19s-2.68.88-3.34 2.19c-1.39-.46-2.9-.2-3.91.81s-1.27 2.52-.81 3.91c-1.31.66-2.19 1.91-2.19 3.34s.88 2.67 2.19 3.34c-.46 1.39-.2 2.9.81 3.91s2.52 1.27 3.91.81c.66 1.31 1.91 2.19 3.34 2.19s2.68-.88 3.34-2.19c1.39.46 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.66 2.19-1.91 2.19-3.34zm-11.71 4.2L6.8 12.46l1.41-1.42 2.26 2.26 4.8-5.23 1.47 1.36-6.2 6.77z" />
		</svg>
	)
}

/** The "spreadsheets are the long tail" heuristic, rendered as an X card. */
export function SacksTweet() {
	return (
		<a
			href={TWEET_URL}
			target="_blank"
			rel="noopener noreferrer"
			// `not-prose` because this renders inside MDX: the article layout's
			// `prose` styles otherwise underline every line of the card (it is one
			// big anchor) and restyle the avatar image.
			className="group not-prose bg-background hover:bg-muted/40 mx-auto my-8 block max-w-xl rounded-2xl border p-5 text-left no-underline transition-colors"
		>
			<div className="flex items-start gap-3">
				<Avatar className="h-12 w-12">
					<AvatarImage src={davidSacksAvatar} alt="David Sacks" />
					<AvatarFallback className="bg-muted text-muted-foreground font-semibold">
						DS
					</AvatarFallback>
				</Avatar>
				<div className="min-w-0 flex-1 leading-tight">
					<div className="flex items-center gap-1">
						<span className="font-bold">David Sacks</span>
						<VerifiedBadge className="size-[18px] shrink-0" />
					</div>
					<p className="text-muted-foreground text-[15px]">@DavidSacks</p>
				</div>
				<XLogo className="text-foreground size-5 shrink-0" />
			</div>

			<p className="mt-3 text-[15px] leading-normal whitespace-pre-line">
				Good heuristic for creating SaaS startups: find a commonly used
				spreadsheet (eg cap tables) and turn it into a dashboard (eg Carta).
				Replace email attachments with workflows. Spreadsheets are the long tail
				of datasets that don&rsquo;t have their own SaaS tool.
			</p>

			<p className="text-muted-foreground mt-3 text-sm">Dec 2018</p>

			<div className="text-muted-foreground group-hover:text-primary mt-3 border-t pt-3 text-sm">
				Read on X →
			</div>
		</a>
	)
}
